export const APP_CONTAINER_MAX_WIDTH_PX = 768;

export const APP_PAGE_MAX_WIDTHS = {
  largest: APP_CONTAINER_MAX_WIDTH_PX,
  medium: 500,
} as const;

export const APP_SIDEBAR_WIDTH_PX = 205;
